<template>
  <div id="footer">
    <img alt="team-icon" :src="image" width="30" height="30" /> Germimiei
    <router-link class="spacing link header-link" to="/privacy">Informativa privacy</router-link>
    <router-link class="spacing link header-link" to="/contact-us">Contattaci</router-link>
    <a href="https://www.facebook.com/Briscola-Chiamata-Online-100898838337009" target="_blank" class="right"><img alt="facebook" :src="require('../assets/icon/facebook.png')" width="40" height="40" class="facebook"/></a>
    <a href="https://twitter.com/germimiei1" target="_blank" class="right"><img alt="twitter" :src="require('../assets/icon/twitter.png')" width="40" height="40" class="twitter"/></a>
    <a href="https://www.youtube.com/channel/UCGnBPNk2t6_01DuZZKnK1PA" target="_blank" class="right"><img alt="youtube" :src="require('../assets/icon/youtube.png')" width="40" height="40" class="youtube"/></a>
    <AudioSetting class="right audio"></AudioSetting>
  </div>
</template>

<script>
import image from "../assets/team-icon.png";
import AudioSetting from "@/components/AudioSetting";

export default {
  name: "Footer",
  components: {
    AudioSetting,
  },
  data: function() {
    return {
      image: image
    };
  }
};
</script>
<style scoped>
#footer {
  padding: 10px;
  background: whitesmoke;
  color: darkslategrey;
  font-size: 14px;
  border-top: solid 3px darkslategrey;
  width: 100%;
  position: absolute;
  bottom: 0;
}

a:link,
a:visited {
  color: darkslategrey;
}
.right {
  margin-left: 0.5em;
  float: right;
  margin-bottom: -10px; 
  margin-top: -5px;
}
.audio {
  margin-top: 0px; 
}

.header-link {
  display: none;
}
@media (min-width: 53em) {
  .header-link {
    display: unset;
  }
}
</style>
